module.exports = __webpack_public_path__ + "img/sales_marketing_bot.d2f0b178.svg";